import { SUPPORTED_BROWSERS } from '@/constants/external/extension';
import * as parser from 'ua-parser-js';
import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import { PLATFORM_LINKS } from '@/constants/external/external-links';

class BrowserUtils {
  /**
   * Check if the browser is Chromium-based
   */
  public isChromium(): boolean {
    return !!window.chrome;
  }

  /**
   * Check if the browser is Chrome ar Mobile Chrome
   */
  public isChrome(): boolean {
    const browser = new parser.UAParser().getBrowser();
    return (
      browser.name === SUPPORTED_BROWSERS.CHROME ||
      browser.name === SUPPORTED_BROWSERS.MOBILE_CHROME
    );
  }

  /**
   * Check if the browser is Safari on desktop
   */
  public isSafariChrome(): boolean {
    const browser = new parser.UAParser().getBrowser();
    return browser.name === SUPPORTED_BROWSERS.SAFARI;
  }

  /**
   * Check if the browser is Safari on mobile
   */
  public isSafariIOS(): boolean {
    const browser = new parser.UAParser().getBrowser();
    return browser.name === SUPPORTED_BROWSERS.MOBILE_SAFARI;
  }

  /**
   * Check if the browser is Microsoft Edge
   */
  public isEdge(): boolean {
    const browser = new parser.UAParser().getBrowser();
    return !!browser?.name?.includes(SUPPORTED_BROWSERS.EDGE);
  }

  public getBrowserApi() {
    //@ts-ignore
    return window.chrome ? chrome : window.browser ? window.browser : null;
  }

  public isMobile(): boolean {
    return isMobile;
  }
  public getCurrentBrowser(): string {
    // Check mobile OS first
    if (isIOS) return SUPPORTED_BROWSERS.MOBILE_SAFARI;
    if (isAndroid) return SUPPORTED_BROWSERS.MOBILE_CHROME;

    // Then check browsers
    if (this.isEdge()) return SUPPORTED_BROWSERS.EDGE;
    if (this.isChrome()) return SUPPORTED_BROWSERS.CHROME;
    if (this.isSafariIOS()) return SUPPORTED_BROWSERS.MOBILE_SAFARI;
    if (this.isSafariChrome()) return SUPPORTED_BROWSERS.SAFARI;
    return SUPPORTED_BROWSERS.CHROME;
  }

  public directUserToStore = () => {
    const getUserBrowser = this.getCurrentBrowser();
    switch (getUserBrowser) {
      case SUPPORTED_BROWSERS.CHROME:
        return PLATFORM_LINKS.EXTENSION_CHROME_STORE;
      case SUPPORTED_BROWSERS.EDGE:
        return PLATFORM_LINKS.EXTENSION_EDGE_STORE;
      case SUPPORTED_BROWSERS.SAFARI:
        return PLATFORM_LINKS.APP_STORE_SAFARI;
      case SUPPORTED_BROWSERS.MOBILE_SAFARI:
        return PLATFORM_LINKS.APP_STORE_IOS;
      case SUPPORTED_BROWSERS.MOBILE_CHROME:
        return PLATFORM_LINKS.PLAY_STORE;
      default:
        return PLATFORM_LINKS.EXTENSION_CHROME_STORE;
    }
  };
}

export const browserUtils = new BrowserUtils();
